<template>
  <div class="px-4 py-2">
    <v-card class="elevation-20">
      <v-card-title style="background-color: #ffa726" primary-title>
        <div style="color: black; font-weight: bold; font-size: 20px;">
          {{ cardname }}
        </div>
        <div style="margin-left: auto; margin-right: 0">
          <v-icon large left @click="cardshow = !cardshow">
            {{ cardshow ? "mdi-minus" : "mdi-crop-square" }}
          </v-icon>
        </div>
      </v-card-title>
      <div v-if="cardshow">
        <v-layout row v-if="[$route.params.id] == 3" py-2>
          <v-flex xs1></v-flex>
          <v-flex xs2 pt-0 px-2>
            <div class="text-input">อายุเริ่มต้น</div>
            <v-text-field
              v-model="ageStart"
              ref="ageStart"
              box
              placeholder="000"
              mask="###"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pt-0 px-2>
            <div class="text-input">อายุสิ้นสุด</div>
            <v-text-field
              v-model="ageEnd"
              ref="ageEnd"
              box
              placeholder="000"
              mask="###"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 px-2 pt-0>
            <div class="text-input">เดือนที่ต้องการตรวจสอบ</div>
            <v-select
              box
              v-model="selMonth"
              ref="selMonth"
              :items="listMonthGAll"
              item-text="text"
              item-value="value"
              value="{ selMonth }"
              placeholder=""
            >
            </v-select>
          </v-flex>
          <v-flex xs2 px-2 pt-0>
            <div class="text-input">ปีที่ต้องการตรวจสอบ</div>
            <v-select
              box
              v-model="selYear"
              ref="selYear"
              :items="selYearArray"
              item-text="text"
              item-value="value"
              value="{ selYear }"
              placeholder=""
            >
            </v-select>
          </v-flex>
          <v-flex xs2 px-5 pt-3>
            <v-btn
              color="info"
              v-if="[$route.params.id] == 3"
              :disabled="!(ageStart && ageEnd)"
              v-on:click="searchByAge"
            ><v-icon class="mr-2 mdi-24px">mdi-magnify</v-icon>ค้นหา</v-btn
            >
          </v-flex>
        </v-layout>
        <v-layout row v-else py-2>
          <v-flex xs2 pt-0 px-2 v-if="[$route.params.id] != 2 && [$route.params.id] != 6"></v-flex>
          <v-flex xs2 pt-0 px-2 v-if="[$route.params.id] <= 2 || [$route.params.id] == 6">
            <div class="text-input">เดือนที่ต้องการตรวจสอบ</div>
            <v-select
              v-model="selMonth"
              ref="selMonth"
              :items="listMonthGAll"
              box
              item-text="text"
              item-value="value"
              value="{ selMonth }"
              placeholder=""
            >
            </v-select>
          </v-flex>
          <v-flex xs3 pt-0 px-2>
            <div class="text-input">ปีต้องการตรวจสอบ</div>
            <v-select
              v-model="selYear"
              ref="selYear"
              box
              :items="selYearArray"
              item-text="text"
              item-value="value"
              value="{ selYear }"
              placeholder=""
            >
            </v-select>
          </v-flex>
          <v-flex xs3 pt-0 px-2 v-if="[$route.params.id] == 2 || [$route.params.id] == 6">
            <div class="text-input">เลือกจังหวัด</div>
            <v-select
              box
              v-model="selProv"
              ref="selProv"
              :items="listCCG"
              item-text="descWithCode"
              item-value="code"
              value="{ selProv }"
              @change="getListtAA"
            >
            </v-select>
          </v-flex>
          <v-flex xs3 pt-0 px-2 v-if="[$route.params.id] == 2 || [$route.params.id] == 6">
            <div class="text-input">เลือกอำเภอ</div>
            <v-select
              :disabled="selProv === null"
              box
              v-model="selDistrict"
              ref="selDistrict"
              :items="listAAG"
              item-text="descWithCode"
              item-value="code"
              value="{ selDistrict }"
              placeholder=""
            >
            </v-select>
          </v-flex>
          <v-flex xs2 px-5 pt-3 v-if="[$route.params.id] == 2">
            <v-btn color="info" v-on:click="searchByDate" :disabled="!selProv"
            ><v-icon class="mr-2 mdi-24px">mdi-magnify</v-icon>ค้นหา</v-btn
            >
          </v-flex>
          <v-flex xs2 px-5 pt-3 v-else>
            <v-btn color="info" v-on:click="searchByDate"
            ><v-icon class="mr-2 mdi-24px">mdi-magnify</v-icon>ค้นหา</v-btn
            >
          </v-flex>
        </v-layout>
      </div>
    </v-card>
    <br />
    <v-layout v-if="showTable">
      <v-flex xs6>
        <v-btn v-if="isBack" color="info" @click="onClickBack"><v-icon class="mr-2 mdi-24px">mdi-step-backward</v-icon>ย้อนกลับ</v-btn>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-btn color="success" @click="print"
        ><v-icon left>mdi-printer</v-icon>พิมพ์</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout v-if="showTable">
      <v-flex
        xs12
        pt-1
        style="text-align: center"
        v-if="[$route.params.id] == 3 || [$route.params.id] == 6"
      ><div class="headLable">
        {{ titleMenuShow }} {{ titleMonth }} พ.ศ.
        {{ selYearShow }} ตามช่วงอายุ {{ ageStatShow }} ปี ถึง
        {{ ageEndShow }} ปี
      </div></v-flex
      >
      <v-flex xs12 pt-1 style="text-align: center" v-else
      ><div class="headLable">
        {{ titleMenuShow }} {{ titleMonth }} พ.ศ. {{ selYearShow }}
      </div></v-flex
      >
    </v-layout>
    <v-layout v-if="showTable" justify-center>
      <v-flex xs12 px-1 pt-1 v-if="[$route.params.id] == 3">
        <v-data-table
          :headers="headersAll"
          :items="listDataAll"
          hide-actions
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td style="text-align: right">{{ props.item.zeroCloum }}</td>
            <td style="text-align: center">{{ props.item.fistCloum }}</td>
            <td style="text-align: right">{{ props.item.twoCloum }}</td>
            <td style="text-align: right">
              {{ formatNumber(props.item.maleTHSum) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.femaleTHSum) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.totalTHSum) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.maleNTHSum) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.femaleNTHSum) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.totalNTHSum) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.totalAll) }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 px-1 pt-1 v-else>
        <v-data-table
          :headers="headersAll2"
          :items="listDataAll"
          hide-actions
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td style="text-align: center">{{ props.item.fistCloum }}</td>
            <td style="text-align: right">{{ props.item.twoCloum }}</td>
            <td style="text-align: right">
              {{ formatNumber(props.item.resultSum1) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.resultSum2) }}
            </td>
            <td style="text-align: right">
              {{ props.item.ratioSum.toLocaleString() }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout v-if="showTable">
      <v-flex
        xs12
        px-1
        pt-1
        v-if="
          ([$route.params.id] == 3 || [$route.params.id] == 6) &&
            flagDistrict === ''
        "
      >
        <v-data-table
          :headers="headers"
          :items="listData"
          :pagination.sync="pagsort"
          :custom-sort="customSort"
          :rows-per-page-items="rowsPerPageItems"
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
          v-bind:class="trTable"
        >
          <template slot="items" slot-scope="props">
            <tr @click="onClickRowByAge(props.item)">
              <td style="text-align: center">{{ props.index + 1 }}</td>
              <td style="text-align: center">
                {{
                  $route.params.id == 3
                    ? props.item.code.toString().substring(0, 2)
                    : props.item.code.toString().substring(2, 4)
                }}
              </td>
              <td>{{ props.item.desc }}</td>
              <td style="text-align: right">
                {{ formatNumber(props.item.maleThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.femaleThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.totalThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.maleNThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.femaleNThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.totalNThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.totalAll) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex
        xs12
        px-1
        pt-1
        v-else-if="
          ([$route.params.id] == 3 || [$route.params.id] == 6) &&
            flagDistrict !== ''
        "
      >
        <v-data-table
          :headers="headers"
          :items="listData"
          :pagination.sync="pagsort"
          :custom-sort="customSort"
          :rows-per-page-items="rowsPerPageItems"
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
          v-bind:class="trTable"
        >
          <template slot="items" slot-scope="props">
            <tr @click="onClickRowByAge(props.item)">
              <td style="text-align: center">{{ props.index + 1 }}</td>
              <td style="text-align: center">
                {{ stringSub(props.item.code, 4, 6) === '00' ? stringSub(props.item.code, 2, 4) : stringSub(props.item.code, 4, 6) }}
              </td>
              <td>{{ props.item.desc }}</td>
              <td style="text-align: right">
                {{ formatNumber(props.item.maleThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.femaleThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.totalThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.maleNThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.femaleNThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.totalNThai) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.totalAll) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex
        xs12
        px-1
        pt-1
        v-else-if="[$route.params.id] <= 2 && flagDistrict === ''"
      >
        <v-data-table
          :headers="headers2"
          :items="listData"
          :pagination.sync="pagsort"
          :custom-sort="customSort"
          :rows-per-page-items="rowsPerPageItems"
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
          v-bind:class="trTable"
        >
          <template slot="items" slot-scope="props">
            <tr @click="onClickRowByDate(props.item)">
              <td style="text-align: center">{{ props.index + 1 }}</td>
              <td style="text-align: center">
                {{
                  $route.params.id == 1
                    ? stringSub(props.item.code, 0, 2)
                    : stringSub(props.item.code, 2, 4)
                }}
              </td>
              <td>{{ props.item.desc }}</td>
              <td style="text-align: right">
                {{ formatNumber(props.item.male) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.female) }}
              </td>
              <td style="text-align: right">
                {{ formatNumber(props.item.total) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex
        xs12
        px-1
        pt-1
        v-else-if="[$route.params.id] <= 2 && flagDistrict !== ''"
      >
        <v-data-table
          :headers="headers2"
          :items="listData"
          :pagination.sync="pagsort"
          :custom-sort="customSort"
          :rows-per-page-items="rowsPerPageItems"
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td style="text-align: center">{{ props.index + 1 }}</td>
            <td style="text-align: center">
              {{ stringSub(props.item.code, 4, 6) }}
            </td>
            <td>{{ props.item.desc }}</td>
            <td style="text-align: right">
              {{ formatNumber(props.item.male) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.female) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.total) }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 px-1 pt-1 v-else>
        <v-data-table
          :headers="headers2"
          :items="listData"
          :pagination.sync="pagsort"
          :custom-sort="customSort"
          :rows-per-page-items="rowsPerPageItems"
          no-data-text="ไม่พบข้อมูล"
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td style="text-align: center">{{ props.index + 1 }}</td>
            <td style="text-align: center">
              {{ props.item.code }}
            </td>
            <td>{{ props.item.desc }}</td>
            <td style="text-align: right">
              {{ formatNumber(props.item.result1) }}
            </td>
            <td style="text-align: right">
              {{ formatNumber(props.item.result2) }}
            </td>
            <td style="text-align: right">
              {{ props.item.ratio.toLocaleString() }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <br>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ textSnackBar }}
      <v-btn
        color="white"
        flat
        @click="snackbar = false"
      >
        ปิด
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import apiRpStat from '../modules/api/apiRpStat.js'
import apiCATM from '../modules/api/apiCATM.js'
import dateFunction from '../modules/models/dateFunction'
import StatReport from '../pdf/StatReport.js'
import getPdf from '../plugins/pdfmake-custom.js'

export default {
  name: 'ReportStat',
  props: ['id'],
  computed: {
    ...sync('*'),
    trTable: function () {
      let classTable = ''
      if (this.flagID === '2') {
        classTable = 'trTable'
      } else if (this.flagID === '3' && (!this.flagDistrict || this.stringSub(this.flagDistrict, 2, 4) === '00')) {
        classTable = 'trTable'
      }

      return classTable
    }
  },
  data () {
    return {
      snackbar: false,
      textSnackBar: null,
      timeout: 60000,
      flagID: null,
      selYear: null,
      selMonth: null,
      selYearArray: [],
      selYearShow: null,
      ageStart: null,
      ageStatShow: null,
      ageEnd: null,
      ageEndShow: null,
      selProv: null,
      selProvArray: [],
      showTable: false,
      rowsPerPageItems: [
        10,
        20,
        30,
        40,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
      ],
      pagsort: {
        sortBy: 'rCode',
        descending: false
      },
      headers: [
        {
          text: 'ลำดับ',
          value: 'code',
          align: 'center',
          width: '10%',
          sortable: false
        },
        { text: 'รหัสจังหวัด', value: 'code', align: 'center', width: '10%' },
        { text: 'จังหวัด', value: 'desc', align: 'center', width: '15%' },
        { text: 'จำนวนชาย (คน)', value: 'male', align: 'center', width: '20%' },
        {
          text: 'จำนวนหญิง (คน)',
          value: 'female',
          align: 'center',
          width: '20%'
        },
        { text: 'รวม', value: 'total', align: 'total', width: '20%' }
      ],
      headers2: [],
      headersAll: [
        {
          text: '',
          value: 'rCode',
          align: 'center',
          sortable: false,
          width: '12%'
        },
        {
          text: '',
          value: 'provDesc',
          align: 'center',
          sortable: false,
          width: '30%'
        },
        {
          text: 'จำนวนชาย (คน)',
          value: 'numMan',
          align: 'center',
          sortable: false,
          width: '20%'
        },
        {
          text: 'จำนวนหญิง (คน)',
          value: 'numWoman',
          align: 'center',
          sortable: false,
          width: '20%'
        },
        {
          text: 'รวม',
          value: 'sumall',
          align: 'center',
          sortable: false,
          width: '20%'
        }
      ],
      headersAll2: [],
      listDataAll: [],
      listData: [],
      titleMenuShow: null,
      titleMenu: [
        'สถิติประชากรรายจังหวัด',
        'สถิติประชากรรายอำเภอ',
        'สถิติประชากรรายจังหวัด',
        'สถิติอัตราการตายต่ออัตราการเกิดรายจังหวัด',
        'สถิติอัตราการแจ้งย้ายเข้าต่ออัตราการแจ้งย้ายออกรายจังหวัด',
        'สถิติประชากรรายอำเภอ',
        'สถิติจำนวนผู้มีสิทธิเลือกตั้ง'
      ],
      titleMonth: null,
      selDistrict: '',
      flagDistrict: '',
      currentDate: null,
      cardshow: true,
      cardname: '',
      listName: [
        '',
        '1. สถิติประชากร รายจังหวัด',
        '2. สถิติประชากร รายอำเภอ',
        '3. สถิติประชากร รายจังหวัด ตามช่วงอายุที่ระบุ',
        '4. สถิติอัตราการตายต่ออัตราการเกิด รายจังหวัด',
        '5. สถิติอัตราการแจ้งย้ายเข้าต่ออัตราการแจ้งย้ายออก รายจังหวัด',
        '6. สถิติจำนวนผู้มีสิทธิเลือกตั้ง'
      ],
      sendDate: '0',
      isBack: false,
      tempData: {
        headersAll: [],
        headersAllTab2: [],
        dataAll: [],
        dataAllTab2: [],
        headers: [],
        headersTab2: [],
        data: [],
        dataTab2: [],
        listAAG: [],
        titleMenuShow: ''
      }
    }
  },
  async created () {
    this.flagID = this.$route.params.id
    let newDate = new Date()
    let yearEnd = newDate.getFullYear()
    if (yearEnd < 2500) yearEnd = yearEnd + 543
    this.currentYear = yearEnd
    this.selYear = yearEnd
    this.selMonth =
      parseInt(this.$route.params.id) === 4 ||
      parseInt(this.$route.params.id) === 5
        ? '00'
        : '01'
    let yearStart = 2539
    for (let i = yearEnd; i >= yearStart; i--) {
      this.selYearArray.push({
        text: i,
        value: i
      })
    }
    this.titleMenuShow = this.titleMenu[this.$route.params.id - 1]
    this.cardname = this.listName[this.$route.params.id]
    var options = { year: 'numeric', month: 'long', day: 'numeric' }
    this.currentDate = newDate.toLocaleString('th-TH', options)
    if (this.listCCG.length === 0) await apiCATM.getCCRp()
  },
  watch: {
    '$route.params.id': {
      async handler (id) {
        if (id !== this.flagID) {
          this.showTable = false
          this.selYear = this.currentYear
          this.titleMenuShow = null
          this.ageEnd = null
          this.ageStart = null
        }
        this.flagID = id
        this.titleMenuShow = this.titleMenu[id - 1]
        this.cardname = this.listName[id]
        this.selMonth =
          parseInt(this.$route.params.id) === 4 ||
          parseInt(this.$route.params.id) === 5
            ? '00'
            : '01'
        this.titleMonth = 'ปี'
        this.selDistrict = ''
        this.pagsort.sortBy = 'rCode'
        if (id === '2' || id === '6') {
          this.selProv = this.listCCG[0].code
          await apiCATM.getAAll(this.selProv)
        }
      }
    }
  },
  methods: {
    async searchByDate () {
      this.listData = []
      this.listDataAll = []
      this.headers2 = []
      this.isBack = false
      this.showTable = true
      this.selYearShow = this.selYear
      this.titleMonth =
        this.selMonth === '00'
          ? 'ปี'
          : ' เดือน' + dateFunction.getMonthThai(this.selMonth)
      this.flagDistrict = this.selDistrict
      let param = 0
      this.headersAll2 = [
        {
          text: '',
          value: 'rCode',
          align: 'center',
          sortable: false,
          width: '12%'
        },
        {
          text: '',
          value: 'provDesc',
          align: 'center',
          sortable: false,
          width: '30%'
        },
        {
          text: 'จำนวนชาย (คน)',
          value: 'numMan',
          align: 'center',
          sortable: false,
          width: '20%'
        },
        {
          text: 'จำนวนหญิง (คน)',
          value: 'numWoman',
          align: 'center',
          sortable: false,
          width: '20%'
        },
        {
          text: 'รวม',
          value: 'sumall',
          align: 'center',
          sortable: false,
          width: '20%'
        }
      ]
      this.headers2 = [
        { text: 'ลำดับ', value: 'index', align: 'center', width: '10%' },
        { text: 'รหัสจังหวัด', value: 'code', align: 'center', width: '10%' },
        { text: 'จังหวัด', value: 'desc', align: 'center', width: '15%' },
        { text: 'จำนวนชาย (คน)', value: 'male', align: 'center', width: '20%' },
        {
          text: 'จำนวนหญิง (คน)',
          value: 'female',
          align: 'center',
          width: '20%'
        },
        { text: 'รวม', value: 'total', align: 'total', width: '20%' }
      ]
      if (this.flagID === '2') {
        param = this.selProv + '' + this.flagDistrict
        this.titleMenuShow = `${this.titleMenu[this.flagID - 1]}ของ${this.selProv === '10' ? '' : 'จังหวัด'}${this.listCCG.find(v => v.code === this.selProv).desc}`
        if (this.selDistrict) this.titleMenuShow += ` ${this.listAAG.find(v => v.code === this.selDistrict).desc}`
      }
      let sendDate = ''
      if (parseInt(this.flagID) < 3) {
        sendDate = this.selYear + ''
        sendDate = sendDate.substring(2, 4) + '' + this.selMonth
      } else {
        sendDate = this.selYear + ''
        sendDate = sendDate.substring(2, 4)
      }
      let flagSend = this.flagID
      if (this.flagID === '1') {
        flagSend = '2'
      }
      try {
        await apiRpStat.rpStat(flagSend, sendDate, param).then((resData) => {
          if (resData.status === 200) {
            let maleSum = 0
            let femaleSum = 0
            let totalSum = 0
            const lowCase = parseInt(this.flagID) < 3
            this.listData = resData.data
            this.listData.forEach((items) => {
              maleSum += lowCase ? items.male : items.result1
              femaleSum += lowCase ? items.female : items.result2
              totalSum += lowCase ? items.total : 0
            })
            this.headersAll2 = [
              {
                text: '',
                value: 'rCode',
                align: 'center',
                sortable: false,
                width: '12%'
              },
              {
                text: '',
                value: 'provDesc',
                align: 'center',
                sortable: false,
                width: '30%'
              },
              {
                text: 'จำนวนชาย (คน)',
                value: 'numMan',
                align: 'center',
                sortable: false,
                width: '20%'
              },
              {
                text: 'จำนวนหญิง (คน)',
                value: 'numWoman',
                align: 'center',
                sortable: false,
                width: '20%'
              },
              {
                text: 'รวม',
                value: 'sumall',
                align: 'center',
                sortable: false,
                width: '20%'
              }
            ]
            this.headers2 = [
              { text: 'ลำดับ', value: 'index', align: 'center', width: '10%' },
              {
                text: 'รหัสจังหวัด',
                value: 'code',
                align: 'center',
                width: '10%'
              },
              { text: 'จังหวัด', value: 'desc', align: 'center', width: '15%' },
              {
                text: 'จำนวนชาย (คน)',
                value: 'male',
                align: 'center',
                width: '20%'
              },
              {
                text: 'จำนวนหญิง (คน)',
                value: 'female',
                align: 'center',
                width: '20%'
              },
              { text: 'รวม', value: 'total', align: 'total', width: '20%' }
            ]
            switch (this.flagID) {
              case '1':
                this.listDataAll = [
                  {
                    fistCloum: '',
                    twoCloum: 'ยอดรวมทั้งประเทศ',
                    resultSum1: maleSum,
                    resultSum2: femaleSum,
                    ratioSum: totalSum
                  }
                ]
                break
              case '2':
                this.headers2[1].text = !this.flagDistrict
                  ? 'รหัสอำเภอ'
                  : 'รหัสตำบล'
                this.headers2[2].text = !this.flagDistrict ? 'อำเภอ' : 'ตำบล'
                this.listDataAll = [
                  {
                    fistCloum: '',
                    twoCloum:
                      this.flagDistrict === ''
                        ? 'ยอดรวมทั้งจังหวัด'
                        : 'ยอดรวมทั้งอำเภอ',
                    resultSum1: maleSum,
                    resultSum2: femaleSum,
                    ratioSum: totalSum
                  }
                ]
                this.tempData = {
                  headersAll: this.headersAll2,
                  dataAll: this.listDataAll,
                  headers: this.headers2,
                  data: this.listData,
                  listAAG: this.listAAG
                }
                break
              case '4':
                this.headers2 = [
                  {
                    text: 'ลำดับ',
                    value: 'code',
                    align: 'center',
                    width: '10%',
                    sortable: false
                  },
                  {
                    text: 'รหัสจังหวัด',
                    value: 'code',
                    align: 'center',
                    width: '10%'
                  },
                  {
                    text: 'จังหวัด',
                    value: 'desc',
                    align: 'center',
                    width: '15%'
                  },
                  {
                    text: 'จำนวนคนตาย (คน)',
                    value: 'result1',
                    align: 'center',
                    width: '20%'
                  },
                  {
                    text: 'จำนวนคนเกิด (คน)',
                    value: 'result2',
                    align: 'center',
                    width: '20%'
                  },
                  {
                    text: 'อัตราคนตาย 1 คนต่อคนเกิด',
                    value: 'ratio',
                    align: 'total',
                    width: '20%'
                  }
                ]
                this.headersAll2 = [
                  {
                    text: '',
                    value: 'rCode',
                    align: 'center',
                    sortable: false,
                    width: '12%'
                  },
                  {
                    text: '',
                    value: 'provDesc',
                    align: 'center',
                    sortable: false,
                    width: '30%'
                  },
                  {
                    text: 'จำนวนคนตาย (คน)',
                    value: 'numMan',
                    align: 'center',
                    sortable: false,
                    width: '20%'
                  },
                  {
                    text: 'จำนวนคนเกิด (คน)',
                    value: 'numWoman',
                    align: 'center',
                    sortable: false,
                    width: '20%'
                  },
                  {
                    text: 'อัตราคนตาย 1 คนต่อคนเกิด',
                    value: 'sumall',
                    align: 'center',
                    sortable: false,
                    width: '20%'
                  }
                ]
                totalSum = femaleSum / maleSum
                this.listDataAll = [
                  {
                    fistCloum: '',
                    twoCloum: 'ยอดรวมทั้งประเทศ',
                    resultSum1: maleSum,
                    resultSum2: femaleSum,
                    ratioSum: totalSum
                  }
                ]
                break
              case '5':
                this.headers2 = [
                  {
                    text: 'ลำดับ',
                    value: 'code',
                    align: 'center',
                    width: '10%',
                    sortable: false
                  },
                  {
                    text: 'รหัสจังหวัด',
                    value: 'code',
                    align: 'center',
                    width: '10%'
                  },
                  {
                    text: 'จังหวัด',
                    value: 'desc',
                    align: 'center',
                    width: '15%'
                  },
                  {
                    text: 'จำนวนการย้ายเข้า',
                    value: 'result1',
                    align: 'center',
                    width: '20%'
                  },
                  {
                    text: 'จำนวนการย้ายออก',
                    value: 'result2',
                    align: 'center',
                    width: '20%'
                  },
                  {
                    text: 'อัตราย้ายเข้า 1 รายการต่อย้ายออก',
                    value: 'ratio',
                    align: 'total',
                    width: '20%'
                  }
                ]
                this.headersAll2 = [
                  {
                    text: '',
                    value: 'fistCloum',
                    align: 'center',
                    sortable: false,
                    width: '12%'
                  },
                  {
                    text: '',
                    value: 'twoCloum',
                    align: 'center',
                    sortable: false,
                    width: '30%'
                  },
                  {
                    text: 'จำนวนการย้ายเข้า',
                    value: 'resultSum1',
                    align: 'center',
                    sortable: false,
                    width: '20%'
                  },
                  {
                    text: 'จำนวนการย้ายออก',
                    value: 'resultSum2',
                    align: 'center',
                    sortable: false,
                    width: '20%'
                  },
                  {
                    text: 'อัตราย้ายเข้า 1 รายการต่อย้ายออก',
                    value: 'ratioSum',
                    align: 'center',
                    sortable: false,
                    width: '20%'
                  }
                ]
                totalSum = femaleSum / maleSum
                this.listDataAll = [
                  {
                    fistCloum: '',
                    twoCloum: 'ยอดรวมทั้งประเทศ',
                    resultSum1: maleSum,
                    resultSum2: femaleSum,
                    ratioSum: totalSum
                  }
                ]
                break
            }
          } else {
            this.listData = []
            this.listDataAll = []
          }
        })
      } catch (error) {
        this.alertBox.showAlert(
          'ไม่สามารถค้นหาข้อมูลได้',
          'error',
          'เกิดข้อผิดพลาด'
        )
      }
    },
    async searchByAge () {
      if (parseInt(this.ageStart) > parseInt(this.ageEnd)) {
        this.snackbar = true
        this.textSnackBar = 'อายุเริ่มต้นต้องน้อยกว่าอายุสิ้นสุด'
        return false
      }

      this.flagDistrict = ''
      this.listData = []
      this.listDataAll = []
      this.showTable = true
      this.isBack = false
      this.selYearShow = this.selYear
      this.ageStatShow = this.ageStart
      this.ageEndShow = this.ageEnd

      this.titleMenuShow = `${this.titleMenu[this.flagID - 1]}`

      let ageStartSend = 0
      let ageEndSend = 0
      if (this.selMonth === '00') {
        this.titleMonth = 'ปี'
      } else {
        this.titleMonth = ' เดือน' + dateFunction.getMonthThai(this.selMonth)
      }
      if (parseInt(this.ageStart) < parseInt(this.ageEnd)) {
        ageStartSend = this.ageStart
        ageEndSend = this.ageEnd
      } else {
        ageStartSend = this.ageEnd
        ageEndSend = this.ageStart
      }

      this.sendDate = this.stringSub(this.selYear, 2, 4) + '' + this.selMonth
      let ageRage = '0/' + ageStartSend + '-' + ageEndSend
      let flagSend = this.flagID
      this.headersAll = [
        {
          text: '',
          value: 'rCode',
          align: 'center',
          sortable: false,
          width: '4%'
        },
        {
          text: '',
          value: 'rCode',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: '',
          value: 'provDesc',
          align: 'center',
          sortable: false,
          width: '10.1%'
        },
        {
          text: 'ชาย(ไทย)',
          value: 'numMan',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'หญิง(ไทย)',
          value: 'numWoman',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'รวม',
          value: 'sumall',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'ชาย(ไม่ใช่ไทย)',
          value: 'numMan',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'หญิง(ไม่ใช่ไทย)',
          value: 'numWoman',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'รวม',
          value: 'numWoman',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'รวมทั้งหมด',
          value: 'numWoman',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
      this.headers = [
        {
          text: 'ลำดับ',
          value: 'seq',
          align: 'center',
          width: '1%',
          sortable: false
        },
        {
          text: 'รหัส',
          value: 'code',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'ชื่อจังหวัด',
          value: 'ccdesc',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'ชาย(ไทย)',
          value: 'thman',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'หญิง(ไทย)',
          value: 'thwoman',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'รวม',
          value: 'thtatal',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'ชาย(ไม่ใช่ไทย)',
          value: 'nthman',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'หญิง(ไม่ใช่ไทย)',
          value: 'nthwoman',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'รวม',
          value: 'ntntotal',
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: 'รวมทั้งหมด',
          value: 'total',
          align: 'center',
          width: '10%',
          sortable: false
        }
      ]

      try {
        await apiRpStat
          .rpStat(flagSend, this.sendDate, ageRage)
          .then((resData) => {
            if (resData.status === 200) {
              this.listData = resData.data
              let maleTHSum = 0
              let femaleTHSum = 0
              let totalTHSum = 0
              let maleNTHSum = 0
              let femaleNTHSum = 0
              let totalNTHSum = 0
              let totalAll = 0
              this.listData.forEach((items) => {
                maleTHSum = maleTHSum + items.maleThai
                femaleTHSum = femaleTHSum + items.femaleThai
                totalTHSum = totalTHSum + items.totalThai
                maleNTHSum = maleNTHSum + items.maleNThai
                femaleNTHSum = femaleNTHSum + items.femaleNThai
                totalNTHSum = totalNTHSum + items.totalNThai
                totalAll = totalAll + items.totalAll
              })
              this.listDataAll = [
                {
                  zeroCloum: '',
                  fistCloum: '',
                  twoCloum: 'ยอดรวมทั้งประเทศ',
                  maleTHSum: maleTHSum,
                  femaleTHSum: femaleTHSum,
                  totalTHSum: totalTHSum,
                  maleNTHSum: maleNTHSum,
                  femaleNTHSum: femaleNTHSum,
                  totalNTHSum: totalNTHSum,
                  totalAll: totalAll
                }
              ]
              this.tempData = {
                headersAll: this.headersAll,
                dataAll: this.listDataAll,
                headers: this.headers,
                data: this.listData
              }
            } else {
              this.listData = []
              this.listDataAll = []
            }
          })
      } catch (error) {
        this.alertBox.showAlert(
          'ไม่สามารถค้นหาข้อมูลได้',
          'error',
          'เกิดข้อผิดพลาด'
        )
      }
    },
    async onClickRowByDate (item) {
      this.isBack = true
      if (this.flagID === '2') {
        let sendDate = ''
        if (parseInt(this.flagID) < 3) {
          sendDate = this.selYear + ''
          sendDate = sendDate.substring(2, 4) + '' + this.selMonth
        } else {
          sendDate = this.selYear + ''
          sendDate = sendDate.substring(2, 4)
        }

        this.flagDistrict = this.stringSub(item.code, 0, 4)
        this.selProv = this.stringSub(item.code, 0, 2)
        this.selDistrict = this.stringSub(item.code, 2, 4)

        this.tempData.titleMenuShow = this.titleMenuShow
        // this.titleMenuShow += ` ${this.tempData.listAAG.find(v => v.code === this.selDistrict).desc}`

        if (this.flagID === '2') {
          try {
            await apiRpStat
              .rpStat(2, sendDate, this.flagDistrict)
              .then((resData) => {
                if (resData.status === 200) {
                  let maleSum = 0
                  let femaleSum = 0
                  let totalSum = 0
                  const lowCase = parseInt(this.flagID) < 3
                  this.listData = resData.data
                  this.listData.forEach((items) => {
                    maleSum += lowCase ? items.male : items.result1
                    femaleSum += lowCase ? items.female : items.result2
                    totalSum += lowCase ? items.total : 0
                  })
                  this.headersAll2 = [
                    {
                      text: '',
                      value: 'rCode',
                      align: 'center',
                      sortable: false,
                      width: '12%'
                    },
                    {
                      text: '',
                      value: 'provDesc',
                      align: 'center',
                      sortable: false,
                      width: '30%'
                    },
                    {
                      text: 'จำนวนชาย (คน)',
                      value: 'numMan',
                      align: 'center',
                      sortable: false,
                      width: '20%'
                    },
                    {
                      text: 'จำนวนหญิง (คน)',
                      value: 'numWoman',
                      align: 'center',
                      sortable: false,
                      width: '20%'
                    },
                    {
                      text: 'รวม',
                      value: 'sumall',
                      align: 'center',
                      sortable: false,
                      width: '20%'
                    }
                  ]
                  this.headers2 = [
                    {
                      text: 'ลำดับ',
                      value: 'index',
                      align: 'center',
                      width: '10%'
                    },
                    {
                      text: 'รหัสจังหวัด',
                      value: 'code',
                      align: 'center',
                      width: '10%'
                    },
                    {
                      text: 'จังหวัด',
                      value: 'desc',
                      align: 'center',
                      width: '15%'
                    },
                    {
                      text: 'จำนวนชาย (คน)',
                      value: 'male',
                      align: 'center',
                      width: '20%'
                    },
                    {
                      text: 'จำนวนหญิง (คน)',
                      value: 'female',
                      align: 'center',
                      width: '20%'
                    },
                    {
                      text: 'รวม',
                      value: 'total',
                      align: 'total',
                      width: '20%'
                    }
                  ]
                  switch (this.flagID) {
                    case '2':
                      this.headers2[1].text = !this.flagDistrict
                        ? 'รหัสอำเภอ'
                        : 'รหัสตำบล'
                      this.headers2[2].text = !this.flagDistrict
                        ? 'อำเภอ'
                        : 'ตำบล'
                      this.listDataAll = [
                        {
                          fistCloum: '',
                          twoCloum:
                            this.flagDistrict === ''
                              ? 'ยอดรวมทั้งจังหวัด'
                              : 'ยอดรวมทั้งอำเภอ',
                          resultSum1: maleSum,
                          resultSum2: femaleSum,
                          ratioSum: totalSum
                        }
                      ]
                      break
                  }
                } else {
                  this.listData = []
                  this.listDataAll = []
                }
              })
          } catch (error) {
            this.alertBox.showAlert(
              'ไม่สามารถค้นหาข้อมูลได้',
              'error',
              'เกิดข้อผิดพลาด'
            )
          }
        }
      }
    },
    async onClickRowByAge (item) {
      let param = ''

      const tempError = this.flagDistrict

      this.flagDistrict = item.code.toString()

      if (this.flagDistrict.substring(4, 6) !== '00') return

      this.isBack = true
      this.tempData.titleMenuShow = this.titleMenuShow

      if (this.flagDistrict.substring(2, 4) === '00') {
        this.headers[2].text = 'ชื่ออำเภอ'
        param = `${this.stringSub(item.code, 0, 2)}/${this.ageStatShow}-${this.ageEndShow}`
        // this.titleMenuShow += ` ${this.listCCG.find(v => v.code === this.stringSub(item.code, 0, 2)).desc}`
      } else {
        this.tempData = {
          ...this.tempData,
          headersAllTab2: this.headersAll,
          dataAllTab2: this.listDataAll,
          headersTab2: this.headers,
          dataTab2: this.listData
        }
        this.headers[2].text = 'ชื่อตำบล'
        param = `${this.stringSub(item.code, 0, 4)}/${this.ageStatShow}-${this.ageEndShow}`
      }

      try {
        await apiRpStat.rpStat(3, this.sendDate, param).then((resData) => {
          if (resData.status === 200) {
            this.listData = resData.data
            let maleTHSum = 0
            let femaleTHSum = 0
            let totalTHSum = 0
            let maleNTHSum = 0
            let femaleNTHSum = 0
            let totalNTHSum = 0
            let totalAll = 0
            this.listData.forEach((items) => {
              maleTHSum = maleTHSum + items.maleThai
              femaleTHSum = femaleTHSum + items.femaleThai
              totalTHSum = totalTHSum + items.totalThai
              maleNTHSum = maleNTHSum + items.maleNThai
              femaleNTHSum = femaleNTHSum + items.femaleNThai
              totalNTHSum = totalNTHSum + items.totalNThai
              totalAll = totalAll + items.totalAll
            })
            this.listDataAll = [
              {
                fistCloum: '',
                twoCloum: this.flagDistrict.substring(2, 4) === '00' ? 'ยอดรวมทั้งจังหวัด' : 'ยอดรวมทั้งอำเภอ',
                maleTHSum: maleTHSum,
                femaleTHSum: femaleTHSum,
                totalTHSum: totalTHSum,
                maleNTHSum: maleNTHSum,
                femaleNTHSum: femaleNTHSum,
                totalNTHSum: totalNTHSum,
                totalAll: totalAll
              }
            ]
          } else {
            this.listData = []
            this.listDataAll = []
          }
        })
      } catch (error) {
        this.flagDistrict = tempError
        this.alertBox.showAlert(
          'ไม่สามารถค้นหาข้อมูลได้',
          'error',
          'เกิดข้อผิดพลาด'
        )
      }
    },
    onClickBack () {
      if (this.flagID === '3') {
        if (this.flagDistrict.substring(2, 4) !== '00') {
          this.headersAll = this.tempData.headersAllTab2
          this.headers = this.tempData.headersTab2
          this.listDataAll = this.tempData.dataAllTab2
          this.listData = this.tempData.dataTab2
          this.flagDistrict = this.flagDistrict.substring(0, 2) + '000000'
        } else {
          this.isBack = false
          this.flagDistrict = ''
          this.headers[2].text = 'ชื่อจังหวัด'

          this.headersAll = this.tempData.headersAll
          this.headers = this.tempData.headers
          this.listDataAll = this.tempData.dataAll
          this.listData = this.tempData.data
        }
      } else {
        this.selDistrict = ''
        this.flagDistrict = ''
        this.isBack = false

        this.headersAll2 = this.tempData.headersAll
        this.headers2 = this.tempData.headers
        this.listDataAll = this.tempData.dataAll
        this.listData = this.tempData.data
      }

      // this.titleMenuShow = this.tempData.titleMenuShow
    },
    async print () {
      const titlePDF =
        this.$route.params.id === '3' || this.$route.params.id === '6'
          ? `${this.titleMenuShow} ${this.titleMonth} พ.ศ. ${this.selYearShow} ตามช่วงอายุ ${this.ageStatShow} ปี ถึง ${this.ageEndShow} ปี`
          : `${this.titleMenuShow === undefined ? '' : this.titleMenuShow} ${
            this.titleMonth
          } พ.ศ. ${this.selYearShow}`
      let dataSend =
        this.$route.params.id === '3' || this.$route.params.id === '6'
          ? await StatReport.StatReport2(
            titlePDF,
            this.listDataAll,
            this.listData,
            this.flagDistrict,
            this.$route.params.id,
            this.currentDate,
            this.flagID
          )
          : await StatReport.StatReport(
            titlePDF,
            this.listDataAll,
            this.listData,
            this.flagDistrict,
            this.$route.params.id,
            this.currentDate,
            this.flagID
          )
      if (dataSend != null) {
        let pdf = await getPdf.pdfMake.createPdfToDataUrl(dataSend)
        this.printDoc(pdf)
      } else {
        this.alertBox.showAlert(
          'ไม่สามารถพิมพ์ไฟล์รายงานได้',
          'error',
          'แจ้งเตือน'
        )
      }
    },
    customSort (items, index, isDesc) {
      items.sort((a, b) => {
        if (index === 'desc') {
          const regex = /(^เขต[เแโใไ]*)|(^จังหวัด[เแโใไ]*)|(^[เแโใไ]*)/g
          const matchesA = a[index].replace(regex, '')
          const matchesB = b[index].replace(regex, '')
          if (!isDesc) {
            return matchesA < matchesB ? -1 : 1
          } else {
            return matchesB < matchesA ? -1 : 1
          }
        }
        if (!isDesc) {
          return a[index] < b[index] ? -1 : 1
        } else {
          return b[index] < a[index] ? -1 : 1
        }
      })
      return items
    },
    formatNumber (val) {
      return dateFunction.formatNumber(val)
    },
    formatRatio (val) {
      return dateFunction.formatRatio(val)
    },
    async getListtAA () {
      this.selDistrict = ''
      await apiCATM.getAAll(this.selProv)
    },
    stringSub (str, start, end) {
      let stringCOde = str + ''
      return stringCOde.substring(start, end)
    }
  }
}
</script>

<style>
.trTable tbody tr:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
